import { css } from 'react-emotion';

export const textOverflowEllipsisStyle = css`
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  display: block;
  overflow: hidden;
`;
